import { Injectable } from "@angular/core";
import { Api } from "../api/api";

import { Gender, User } from "../../models/user";

import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import { SearchParamsMeeting } from "../user/user";
import { CalendarProvider } from "../../providers/calendar/calendar";

export interface TodayTotalMeetingEntriesData {
  num: number;
}

@Injectable()
export class MeetingEntryProvider {
  private url: string = "meeting_entries";
  constructor(public api: Api, public calendarProvider: CalendarProvider) {}

  loadFemale(page: number, params: SearchParamsMeeting): Observable<User[]> {
    let loadParamsMeeting: any = {};
    let date = params.date.split("T")[0];
    if (!date) {
      date = this.calendarProvider.setLocalISODate(new Date()).split("T")[0];
    }

    loadParamsMeeting = {
      page: page,
      query: JSON.stringify(params),
      date_query: date,
    };
    return this.api
      .get(this.url + "/females", false, loadParamsMeeting)
      .map((users) => users.map((user) => new User(user)));
  }

  loadMale(page: number, params: SearchParamsMeeting): Observable<User[]> {
    let loadParamsMeeting: any = {};
    let date = params.date.split("T")[0];
    if (!date) {
      date = this.calendarProvider.setLocalISODate(new Date()).split("T")[0];
    }

    loadParamsMeeting = {
      page: page,
      query: JSON.stringify(params),
      date_query: date,
    };
    return this.api
      .get(this.url + "/males", false, loadParamsMeeting)
      .map((users) => users.map((user) => new User(user)));
  }

  meeting(gender: Gender, data: any[]): Observable<any> {
    let url: string = "/update_";
    if (gender === Gender.Male) {
      url = url + "male";
    } else {
      url = url + "female";
    }
    return this.api.post(this.url + url, {
      meeting_entries: data,
    });
  }

  fetchTodayMaleMeetingEntryNumber(): Observable<any> {
    return this.api.get(this.url + "/total_today_male_meeting_num");
  }

  fetchTodayFemaleMeetingEntryNumber(): Observable<any> {
    return this.api.get(this.url + "/total_today_female_meeting_num");
  }
}



// WEBPACK FOOTER //
// ./src/providers/meeting-entry/meeting-entry.ts